module.exports = __webpack_public_path__ + "img/Weapon_159.6a235415.png";